module.exports = __webpack_public_path__ + "img/github.83a16b3e.png";